import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Feedback1 = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../images/feedback_1.jpg"
      alt="collar inteligente Kolyy"
    />
  );
};

export default Feedback1;
